module.exports = __webpack_public_path__ + "img/login_bg.5c537402.jpg";